import { render, staticRenderFns } from "./Dashboardnew_copy.vue?vue&type=template&id=0e2d8827"
import script from "./Dashboardnew_copy.vue?vue&type=script&lang=js"
export * from "./Dashboardnew_copy.vue?vue&type=script&lang=js"
import style0 from "./Dashboardnew_copy.vue?vue&type=style&index=0&id=0e2d8827&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports